/* eslint-disable no-undef */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ItemService from "../../../services/supplier_appCommonService";

const initialState = {
    data: [],
    companyDetail: {},
    status: true,
    detailStatus: true,
    saveStatus: false,
    pagination: {
        page: "",
        per_page: "",
        total: ""
    }
};

export const companySlice = createSlice({
    name: "company",
    initialState,
    reducers: {
        clearCompanyDetail(state, action) {
            state.companyDetail = {};
            state.detailStatus = true;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCompanyList.pending, (state, action) => {
                state.status = true;
            })
            .addCase(getCompanyList.fulfilled, (state, action) => {
                state.data = action.payload?.data || [];
                state.pagination.page = action.payload?.page;
                state.pagination.per_page = action.payload?.per_page;
                state.pagination.total = action.payload?.total;
                state.status = false;
            })
            .addCase(getCompanyList.rejected, (state, action) => {
                state.status = false;
            })
            .addCase(getCompanyDetail.pending, (state, action) => {
                state.detailStatus = true;
            })
            .addCase(getCompanyDetail.fulfilled, (state, action) => {
                state.companyDetail = action.payload?.data || {};
                state.detailStatus = false;
            })
            .addCase(getCompanyDetail.rejected, (state, action) => {
                state.detailStatus = false;
            })
            .addCase(addCompany.pending, (state, action) => {
                state.saveStatus = true;
            })
            .addCase(addCompany.fulfilled, (state, action) => {
                state.saveStatus = false;
            })
            .addCase(addCompany.rejected, (state, action) => {
                state.saveStatus = false;
            })
            .addCase(updateCompany.pending, (state, action) => {
                state.saveStatus = true;
            })
            .addCase(updateCompany.fulfilled, (state, action) => {
                state.saveStatus = false;
            })
            .addCase(updateCompany.rejected, (state, action) => {
                state.saveStatus = false;
            })
    }
});

export const { clearCompanyDetail } = companySlice.actions;
export default companySlice.reducer;

export const getCompanyList = createAsyncThunk('getCompanyList', async (param) => {
    console.log(">> loaded getCompanyList");
    const res = await ItemService.getCompanyList(param);
    return res;
})

export const getCompanyDetail = createAsyncThunk('getCompanyDetail', async (param) => {
    console.log(">> loaded getCompanyDetail");
    const res = await ItemService.getCompanyDetail(param);
    return res;
})

export const addCompany = createAsyncThunk('addCompany', async (param) => {
    console.log(">> loaded addCompany");
    const res = await ItemService.addCompany(param);
    return res;
})

export const updateCompany = createAsyncThunk('updateCompany', async (param) => {
    console.log(">> loaded updateCompany");
    const res = await ItemService.updateCompany(param);
    return res;
})

export const deleteCompany = createAsyncThunk('deleteCompany', async (param) => {
    console.log(">> loaded deleteCompany");
    const res = await ItemService.deleteCompany(param);
    return res;
})
